import React from 'react';
import './App.css';
import { Box } from '@mui/material';
import Header from './Header';
import Intro from './Intro';
import VerticalLinearStepper from './VerticalLinearStepper';

function App() {
  return (
    <div className="App">
      <Header />
      <Intro />
      <Box sx={{ flexGrow: 1, m: 4 }}>
        <VerticalLinearStepper />
      </Box>
    </div>
  );
}

export default App;
